/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ContactInformationPage = lazyLoad(
  () => import('./index'),
  module => module.ContactInformationPage
);
